(function ($) {
    $(document).ready(function () {
        init();
        var pdsCountryCodeFetchCountry = $("#hdnPdsCountryCode").val();
        var sdsCountryCodeFetchCountry = $("#hdnSdsCountryCode").val();
        if ($("#divPartialViewSds").length == 1) {
            fetchSdsPartialView();
        }
        if (!$("#ddlCountry")) return;
        $("#ddlCountry").change(function () {
            if ($("#ddlCountry").val() == -1) {
                $("#divPartialView").html("");
                fetchPdsPartialView(true);
                return;
            }
            fetchPdsPartialView();
        });
        if (!$("#ddlCountrySds")) return;
        $(document).on('change', "#ddlCountrySds", function () {
            ShowHideSds();
        });
        $("[lightboxmodalcontainer]").on("shown.bs.modal",
            function () {
                var autoContentDisplayAttr = 'auto-display-content';
                var selectorAttr = 'content-selector';
                var replaceHtmlTagsAttr = 'remove-html-tags';
                var dynamicText = '{prodNameLabel}';
                var showAutoDisplayContent = $('[' + autoContentDisplayAttr + ']');
                if ($("#ddlCountry:visible").val() == -1) {
                    $("#divPartialView:visible").html('<svg style="animation:fa-spin 1s infinite steps(8);height:25px;" class="svg-inline--fa fa-spinner fa-w-16 fa-pulse" aria-hidden="true" data-prefix="fas" data-icon="spinner" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path></svg>');
                    populateCountryDropDown();
                }

                /*Product textbox auto populate title*/
                if (showAutoDisplayContent && showAutoDisplayContent.length > 0) {
                    for (var i = 0; i <= showAutoDisplayContent.length - 1; i++) {
                        var component = showAutoDisplayContent[i];
                        if (component && $(component).attr(autoContentDisplayAttr) === "True") {
                            var componentSelectorValue = $(component).attr(selectorAttr) ? $(component).attr(selectorAttr) : '';
                            var componentReplaceTagsValue = $(component).attr(replaceHtmlTagsAttr) ? $(component).attr(replaceHtmlTagsAttr) : '';
                            if ($(componentSelectorValue) && $(componentSelectorValue).length > 0) {
                                var textToCopy = $($(componentSelectorValue)[0]).text();
                                if (componentReplaceTagsValue.length > 0) {
                                    if (componentReplaceTagsValue.indexOf(',') > -1) {
                                        var htmlTags = componentReplaceTagsValue.split(',');
                                        if (htmlTags && htmlTags.length > 0) {
                                            for (var j = 0; j <= htmlTags.length - 1; j++) {
                                                textToCopy = textToCopy.replace(htmlTags[i]);
                                            }
                                        }
                                    } else {
                                        textToCopy = textToCopy.replace(componentReplaceTagsValue);
                                    }
                                }
                                $(component).val(textToCopy);
                            }
                        }
                    }
                }
            });
        function populateCountryDropDown() {
            if ($("#ddlCountry:visible").length > 0) {
                fetchPdsPartialView();
                $.ajax({
                    url: $("#CountryEndpoint_PDS").val(),
                    type: 'POST',
                    async: true,
                    data: {
                        TemplateId: $("#hdnPageTemplate").val(),
                        ProductName: $("#hdnProduct").val(),
                        Language: $("#languagePds").val(),
                        DatasourceId: $("#hdnDataSourceIdPds").val(),
                        CountryCode: pdsCountryCodeFetchCountry,
                        Type: "PDS"
                    },
                    dataType: "html",
                    success: function (response) {
                        $("#ddlCountry").empty();
                        var data = JSON.parse(response);
                        var options = "";
                        var selectedCountryinDropdown = "-1";
                        for (var i = 0; i < data.length; i++) {
                            if (data[i].CountryCode === "-1")
                                options += "<option value='" + data[i].CountryCode + "'>" + data[i].CountryName + "</option>";
                            else {
                                options += "<option lang='en' value='" + data[i].CountryCode + "'>" + data[i].CountryName + "</option>";
                            }
                            if (data[i].IsSelected) {
                                selectedCountryinDropdown = data[i].CountryCode;
                            }
                        }
                        $("#ddlCountry").append(sanitizeHtmlStrings(options, {
                            whiteList: {
                                option: ["value", "lang"]
                            }
                        }));
                        $("#ddlCountry").val(selectedCountryinDropdown);
                    },
                    failure: function (msg) {
                    }
                });
            }
        }
        function fetchPdsPartialView(onChange) {
            $.ajax({
                url: $("#URLEndpointName").val(),
                type: 'POST',
                async: true,
                data: {
                    countryIso: $("#ddlCountry").val() == -1 && !onChange ? pdsCountryCodeFetchCountry : $("#ddlCountry").val(),
                    productName: $("#hdnProduct").val(),
                    language: $("#languagePds").val(),
                    productCountry: pdsCountryCodeFetchCountry,
                    datasourceId: $("#hdnDataSourceIdPds").val(),
                    pageTemplateId: $("#hdnPageTemplate").val()
                },
                dataType: "html",
                success: function (data) {
                    $("#divPartialView").html(sanitizeHtmlStrings(data, {
                        whiteList: {
                            div: ["class", "data-analytics"],
                            a: ["title", "href", "class", "target", "document-type", "data-bs-toggle", "data-bs-target", "aria-label", "lang"],
                            span: ["class"],
                            i: ["class"],
                            input: ["type", "id", "value"],
                            h3: ["class"]
                        }
                    }));
                    init();
                    if (data.length <= 54)
                        $("#ResultsNotFound").show();
                    else
                        $("#ResultsNotFound").hide();
                },
                failure: function (msg) {
                }
            });
        }
        function fetchSdsPartialView(onChange) {
            $("#dvSdsLoader").show();
            $.ajax({
                url: $("#URLEndpointNameSds").val(),
                type: 'POST',
                async: true,
                data: {
                    countryIso: $("#ddlCountrySds").val() == -1 && !onChange ? sdsCountryCodeFetchCountry : $("#ddlCountrySds").val(),
                    type: "SDS",
                    productName: $("#hdnProductName").val().trim(),
                    language: $("#languageSds").val(),
                    datasourceId: $("#hdnDataSourceIdSds").val(),
                    productCode: $("#hdnProductCode").val()
                },
                dataType: "html",
                success: function (data) {
                    $("#divPartialViewSds").html(sanitizeHtmlStrings(data, {
                        whiteList: {
                            div: ["class", "data-analytics", "data-country", "id", "style"],
                            a: ["title", "href", "class", "target", "document-type", "data-bs-toggle", "data-bs-target", "aria-label", "lang"],
                            span: ["class", "lang", "data-cookie-name", "data-cookie-value", "data-cookie-duration"],
                            i: ["class"],
                            input: ["type", "id", "value", "class"],
                            h3: ["class", "id", "lang", "style"],
                            table: ["class"],
                            tbody: ["class"],
                            tr: ["class"],
                            td: ["class"],
                            select: ["class", "id"],
                            option: ["class", "value", "lang", "selected"],
                            svg: ["style", "class", "aria-hidden", "data-prefix", "data-icon", "data-fa-i2svg", "role", "xmlns", "viewBox"],
                            path: ["fill", "d"]
                        }
                    }));
                    init();
                    var defaultCountry = $("#hdnSdsCountryCode").val();
                    if (defaultCountry == "" || $("#ddlCountrySds").find('option[value=\"' + defaultCountry + '\"]').length == 0) {
                        $("#ddlCountrySds").val("-1");
                    } else {
                        $("#ddlCountrySds").val(defaultCountry);
                    }
                    ShowHideSds();
                    $("#dvSdsLoader").hide();
                    //set focus to the dropdown
                    $("#ddlCountrySds").focus();
                },
                failure: function (msg) {
                }
            });
        }
    });
    function setCookie(cname, cvalue, cduration) {
        isOneTrustLoaded().then(function () {
            if (typeof consentManager !== "undefined" && !consentManager.isCategoryActive("SDSDownload")) {
                return;
            }

            if (!cname || !cvalue) return false;
            var d = new Date();
            d.setTime(d.getTime() + (cduration * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        });
    }
    function init() {
        var $sdslinks = $('.sds-cookie-link');
        if (!$sdslinks.length) return;
        $sdslinks.on('click', function () {
            var cname = $(this).data('cookie-name'),
                cvalue = $(this).data('cookie-value'),
                cduration = parseInt($(this).data('cookie-duration'), 10);
            setCookie(cname, cvalue, cduration);
        });
    }
}(window.jQuery));

function ShowHideSds() {
    $("#divSdsDocuments").hide();

    if ($("#ddlCountrySds").val() != "-1") {
        $("#divSdsDocuments").show();
    }
    $(".no-sds-docs").hide();
    var selectedCountry = $("#ddlCountrySds").children("option:selected").text().toLowerCase().replaceAll(" ", "");
    $(".resource-list-country").hide();

    var resourceListCountries = $(".resource-list-country[data-country='" + selectedCountry + "']");
    resourceListCountries.show();

    if (resourceListCountries.length === 0) {
        $(".no-sds-docs").show();
    }
}

(function ($) {
    $(document).ready(function () {
        var apiDownloadurl = "/api/SdsLanding/GetSdsDocuments";
        var doclistResources = document.querySelectorAll(".download-link");
        if (doclistResources.length > 0) {
            var prodCode = doclistResources[0].getAttribute("data-productcode");
            $.ajax({
                type: 'POST',
                url: apiDownloadurl,
                async: true,
                data: {
                    productCode: prodCode
                },
                success: function (data, status, xhr) {
                    if (data.length > 0) {
                        doclistResources.forEach(function (listDocData) {
                            var docid = listDocData.getAttribute("data-docid");
                            var downloadUrl = $.grep(data, function (p) { return p.MaterialId == docid; })
                                .map(function (p) { return p.DocumentUrl; });
                            downloadUrl = window.location.origin + "/downloadfile.ashx?url=" + downloadUrl;
                            listDocData.setAttribute("href", downloadUrl);
                        });
                        $(".dvSdsLoader").hide();
                        $(".download-link").css("display", "flex");
                    } else {
                        $(".dvSdsLoader").hide();
                        $(".download-link").css("display", "flex");
                        return false;
                    }
                }
            });
        }
    });
}(window.jQuery));
/*Analytics*/
analytics.eventConfig.push(
    {
        "target": "span#divProductPDSDetails",
        "codeId": "psd",
        "events": [
            {
                "eventTarget": "#ddlCountry",
                "eventType": "change",
                "tags": {
                    "componentId": "psd",
                    "componentName": "pds sds datasheet",
                    "elementText": "",
                    "elementType": "country dropdown",
                    "event": "navigation",
                    "eventType": "country selection click",
                    "parentName": "",
                    "parentTitle": "",
                    "titleText": ""
                }
            }
        ]
    },
    {
        "target": "div#divProductSDSDetails",
        "codeId": "psd",
        "events": [
            {
                "eventTarget": "#ddlCountrySds",
                "eventType": "change",
                "tags": {
                    "componentId": "psd",
                    "componentName": "pds sds datasheet",
                    "elementText": "",
                    "elementType": "country dropdown",
                    "event": "navigation",
                    "eventType": "country selection click",
                    "parentName": "lightbox",
                    "parentTitle": "",
                    "titleText": ""
                }
            }
        ]
    }
)